import type { FC } from 'react';

import { AsyncMultiSelect } from '@zen/DesignSystem';

import {
  formatTerminalOrGroupLabel,
  isGroupMemberOption,
  type LoadTerminalAndGroupOptions,
  type TerminalOrGroup,
  type TerminalOrGroupOption,
  useTerminalAndGroupOptions
} from '../TerminalsAndGroupsSelect';

interface Props {
  hasError?: boolean;
  includeGroups?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  name: string;
  onBlur?: () => void;
  onChange?: (value: TerminalOrGroup[]) => void;
  placeholder?: string;
  renderMenuInPortal?: boolean;
  value: TerminalOrGroup[];
  variant?: 'default' | 'inline';
}

const TerminalsAndGroupsMultiSelect: FC<Props> = (props) => {
  const { includeGroups = true, ...rest } = props;
  const loadOptions: LoadTerminalAndGroupOptions = useTerminalAndGroupOptions(includeGroups);

  return (
    <AsyncMultiSelect<TerminalOrGroupOption>
      {...rest}
      defaultOptions={true}
      formatOptionLabel={formatTerminalOrGroupLabel}
      isOptionDisabled={isGroupMemberOption}
      loadOptions={loadOptions}
    />
  );
};

export type { Props as TerminalsAndGroupsMultiSelectProps };

export default TerminalsAndGroupsMultiSelect;
